import { Component, inject } from '@angular/core';

import { DialogHandlerComponent } from '../../shared/dialog-handler/dialog-handler.component';

import { FleetService } from '../../services/fleet.service';

import { Fleet } from '../../interfaces/fleet';
import { Ship } from '../../interfaces/ship';

@Component({
  selector: 'ism-assign-ships',
  standalone: false,
  templateUrl: './assign-ships.component.html',
})
export class AssignShipsComponent extends DialogHandlerComponent {
  fleetService = inject(FleetService);

  title: string = 'Assign Ships';
  fleets: Fleet[] = [];
  baseFleet: Fleet;
  selectedFleet: Fleet;
  shipById: { [key: string]: Ship; } = {};
  newFleetCount: number = 0;

  constructor () {
    super();

    let importFleets = this.data.document as Fleet[];
    this.fleets = importFleets.map(fleet => {
      let newFleet = Object.assign({}, fleet);
      this.shipById = newFleet.ships.reduce(
        (hash, ship) => {
          hash[ship._id] = ship;
          return hash;
        },
        this.shipById
      );
      return newFleet;
    });
    this.baseFleet = this.fleets[0];
    this.selectedFleet = this.baseFleet;
  };

  newFleet (fleetName: string): Fleet {
    let newFleet = this.fleetService.getNewFleet(this.baseFleet.campaignId, this.baseFleet.raceId, this.baseFleet.locationHex);
    newFleet.fleetName = fleetName;
    newFleet.shipIds = [];
    newFleet.starSystemId = this.baseFleet.starSystemId;
    newFleet.turnActivated = this.session.campaign.turn;
    return newFleet;
  };

  addFleet () {
    this.newFleetCount++;
    this.fleets.push(this.newFleet("New Fleet " + this.newFleetCount));
  };

  moveShip (currentFleet: Fleet, shipId: string) {
    if (currentFleet !== this.selectedFleet) {
      currentFleet.shipIds.splice(currentFleet.shipIds.indexOf(shipId), 1);
      this.selectedFleet.shipIds.push(shipId);
    }
  };

  override save () {
    this.dialogRef.close({
      documentName: "Fleet",
      document: this.fleets
    });
  };
};
